import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from "react";
import "../styles/chat.css";
import "../styles/loginModal.css";
import ChatComp from "../components/chatComp";
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Menu } from '@headlessui/react';
import ChatGPTTypingEffect from "../components/componetsChat/ChatGPTTypingEffect";
import AIThinkingComponent from "../components/ui/AIThinkingComponent";

// Import Firebase modules
import { initializeApp, getApps, getApp } from "firebase/app";
import {
    getAuth,
    RecaptchaVerifier,
    signInWithPhoneNumber,
    GoogleAuthProvider,
    signInWithPopup,
    onAuthStateChanged,
    signOut,
} from "firebase/auth";


// Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyDfdKexK4kTp2mGgceuYTJgsS4_4ba9XOo",
    authDomain: "routechef-b1c5f.firebaseapp.com",
    projectId: "routechef-b1c5f",
    storageBucket: "routechef-b1c5f.appspot.com",
    messagingSenderId: "863459882866",
    appId: "1:863459882866:web:a224e5dcfb66a13ab48feb",
    measurementId: "G-V9KMLS73T7",
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

const auth = getAuth(app);

const generateRandomUserId = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 12; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

function getAnonHash() {
    const localIdKey = "routechef_anon_id";

    // Stable UUID stored in localStorage
    let anonId = localStorage.getItem(localIdKey);
    if (!anonId) {
        anonId = crypto.randomUUID();
        localStorage.setItem(localIdKey, anonId);
    }

    // Components that contribute to the hash
    const fingerprint = [
        navigator.userAgent,
        navigator.platform,
        window.screen.width + "x" + window.screen.height,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        navigator.language,
        anonId
    ].join("|");

    // Simple hash function (FNV-1a for example)
    let hash = 2166136261;
    for (let i = 0; i < fingerprint.length; i++) {
        hash ^= fingerprint.charCodeAt(i);
        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }

    const id = ("anon" + (hash >>> 0).toString(16));
    // const id = "webbot_9f3a2c1b"
    console.log("User Id:", id);
    return id;
}

const getOrCreateUserId = async () => {
    // let userId = localStorage.getItem('routechef_userId');
    // if (!userId) {
    //     userId = generateRandomUserId();
    //     localStorage.setItem('routechef_userId', userId);
    // }
    // const response = await fetch("https://api.ipify.org?format=json");
    // const data = await response.json();
    // const userId = data.ip;
    // return userId;

    return getAnonHash();
};

export default function Chat() {

    const [inputMessage, setInputMessage] = useState("");
    const [connectionId, setConnectionId] = useState(null);
    const [chatMessages, setChatMessages] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pendingMessages, setPendingMessages] = useState(new Map());
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUserClickSignIn, setUserClickSignIn] = useState(false);
    const [mobileNumber, setMobileNumber] = useState("");
    const [idToken, setIdToken] = useState(null);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [confirmationResult, setConfirmationResult] = useState(null);
    const [connectionError, setConnectionError] = useState(null);
    const [userProfile, setUserProfile] = useState({ code: 1 });
    const socketRef = useRef(null);
    const inactivityTimeoutRef = useRef(null);
    const chatHistoryRef = useRef(null);
    const chatHistoryRef2 = useRef(null);
    const recaptchaVerifierRef = useRef(null);
    const [lastFailedMessage, setLastFailedMessage] = useState(null);
    const [lastMessage, setLastMessage] = useState(null);
    const [lastUserMessage, setLastUserMessage] = useState(null);
    const [firstMessageAfterLogin, setFirstMessageAfterLogin] = useState(false);
    const [oldFromField, setOldFromField] = useState(null);
    const [userId, setUserId] = useState(getOrCreateUserId());
    const userIdRef = useRef(null);
    const isProduction = false;
    const [fromField, setFromField] = useState(null);
    const apiKey = "test_dev";
    const [showWelcome, setShowWelcome] = useState(false);
    const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
    const waitForResRef = useRef(false);
    const [pendingPaginationUpdate, setPendingPaginationUpdate] = useState(null);
    const [selectedTravelOptions, setSelectedTravelOptions] = useState({});
    const [currentMessageId, setCurrentMessageId] = useState(null);
    const [showWelcomeMessage, setShowWelcomeMessage] = useState(true);
    const isFirstConnection = useRef(true);
    const [shouldScrollToBottom, setShouldScrollToBottom] = useState(false);
    const [isMoreRepliesLoading, setIsMoreRepliesLoading] = useState(false);
    const [isTypingEffectCompleted, setTypingEffectCompleted] = useState(true);
    const [heroMessageSent, setHeroMessageSent] = useState(false);
    const [isRecaptchaInitialized, setIsRecaptchaInitialized] = useState(false);
    const [isInitializing, setIsInitializing] = useState(true);
    const [connectionAttempts, setConnectionAttempts] = useState(0);
    const MAX_CONNECTION_ATTEMPTS = 5;
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    const [isLoadingOlderMessages, setIsLoadingOlderMessages] = useState(false);
    const [hasMoreHistory, setHasMoreHistory] = useState(true);
    const hasMoreHistoryRef = useRef(hasMoreHistory);
    const [lastEvaluatedTimestamp, setLastEvaluatedTimestamp] = useState(null);
    const lastEvaluatedTimestampRef = useRef(null); // Add ref for immediate access
    const idTokenRef = useRef(null); // Add ref for idToken
    const fromFieldRef = useRef(null); // Add ref for fromField
    const navigate = useNavigate();
    const [showLogout, setShowLogout] = useState(false);
    const [recaptchaContainerId, setRecaptchaContainerId] = useState("recaptcha-container");
    const [lastFailedHistoryParams, setLastFailedHistoryParams] = useState(null);
    const heroMessageSentRef = useRef(false); // Add this near other refs
    const historyLoadedRef = useRef(false); // Add this to track if history has been loaded
    const [isLoginLoading, setIsLoginLoading] = useState(false); // Add this state for login loading
    // Add state to track the index of the current bot message being animated
    const [currentBotMessageIdx, setCurrentBotMessageIdx] = useState(0);
    // Add this ref to track the last paginated result queue advancement
    const lastPaginatedAdvance = useRef({ idx: -1, id: null });
    const [canShowTyping, setCanShowTyping] = useState(false);
    const [thinkingData, setThinkingData] = useState(null);
    const [botResponseCount, setBotResponseCount] = useState(0);

    const [historyLoaded, setHistoryLoaded] = useState(false);
    const handleMigrationStatus = useRef(0);

    // --- Robust scroll restoration for prepend pagination ---
    const prevScrollHeightRef = useRef(0);
    const prevScrollTopRef = useRef(0);
    const isPrependingRef = useRef(false);

    const wsUrl = isProduction
        ? "wss://ntqajgnw81.execute-api.ap-south-1.amazonaws.com/production/"
        : "wss://ntqajgnw81.execute-api.ap-south-1.amazonaws.com/Development/";
    console.log("wsUrl:", wsUrl);
    // Refs for WebSocket callbacks and latest state
    const connectionIdRef = useRef(connectionId);
    const firstMessageAfterLoginRef = useRef(firstMessageAfterLogin);
    const oldFromFieldRef = useRef(oldFromField);
    const lastFailedMessageRef = useRef(lastFailedMessage);
    const latestStateRef = useRef({}); // New ref to hold latest state for callbacks
    const lastMessageRef = useRef(lastMessage);
    const lastUserMessageRef = useRef(lastUserMessage);

    const location = useLocation();
    useEffect(() => {
        if (location.state?.fromHero && location.state.heroInput) {
            setShowWelcome(false);
            //setInputMessage(location.state.heroInput);
            setIsLoading(true);
            setHeroMessageSent(false); // Reset flag on navigation
            setShowWelcomeMessage(false);
            isFirstConnection.current = false;
        }
    }, [location]);

    // Helper function to process paginated results
    const processPaginatedResults = useCallback((paginated_results) => {
        const processedTravelOptions = [];
        for (let i = 0; i < paginated_results.length; i++) {
            const routeData = paginated_results[i][2];
            if (!routeData) {
                console.warn(`routeData at index ${i} is undefined or null. Skipping this entry.`);
                continue;
            }

            let append2 = {};
            let tDuration = 0;
            let tPrice = (routeData.route_type && routeData.route_type == 2) ? routeData.total_fare || 0 : 0;
            append2.timelineSteps = [];
            append2.tag = paginated_results[i][1][0] || "";
            append2.availability = '';
            append2.modes = [];

            if (routeData.num_stops !== undefined) {
                append2.stops = `${routeData.num_stops} change stop`;
            } else {
                append2.stops = "N/A stops";
            }
            append2.currency = "₹";

            if (routeData.nodes && routeData.nodes.length > 0) {
                const lastNodeIndex = routeData.nodes.length - 1;
                if (routeData.nodes[0] && routeData.nodes[0].segment) {
                    const originSegment = routeData.nodes[0].segment;
                    const originDate = new Date(originSegment.origin_dep_dt);
                    append2.departure = {
                        location: originSegment.origin_code_iata || originSegment.origin_code,
                        time: originDate.toTimeString().slice(0, 5),
                        date: `${originDate.getDate()} ${originDate.toLocaleString("default", { month: "short" })}`,
                    };
                }

                if (routeData.nodes[lastNodeIndex] && routeData.nodes[lastNodeIndex].segment) {
                    const destSegment = routeData.nodes[lastNodeIndex].segment;
                    const arrivalDate = new Date(destSegment.dest_arr_dt);
                    append2.arrival = {
                        location: destSegment.dest_code_iata || destSegment.dest_code,
                        time: arrivalDate.toTimeString().slice(0, 5),
                        date: `${arrivalDate.getDate()} ${arrivalDate.toLocaleString("default", { month: "short" })}`,
                    };
                }

                let cou = true;
                for (let j = 0; j < routeData.nodes.length; j++) {
                    const node = routeData.nodes[j];
                    if (!node || !node.segment) continue;

                    const segment = node.segment;
                    tDuration += segment.duration_mins;

                    if (routeData.route_type != 2) {
                        if (!routeData.total_fare && segment.seat_avail_ui?.fare) {
                            tPrice += segment.seat_avail_ui.fare;
                        }
                    }

                    if (segment.origin_comment_web) {
                        const tr = {
                            type: "LocationComp",
                            icon: <img src="/icon3.svg" alt="Location Icon" style={{ width: 24, height: 24 }} />,
                            data: {
                                name: segment.origin_comment_web_title,
                                description: [segment.origin_comment_web].filter(Boolean),
                                isLayover: false,
                            },
                        };
                        append2.timelineSteps.push(tr);
                    }

                    if (segment.flight_num) {
                        const tr = {
                            type: "FlightCard",
                            icon: <img src="/icon4.svg" alt="Flight Icon" style={{ width: 24, height: 24 }} />,
                            data: {
                                trainName: segment.carrier,
                                trainNumber: segment.flight_num,
                                trainType: "Flight",
                                from: {
                                    station: segment.origin_name,
                                    code: segment.origin_code_iata,
                                    time: new Date(segment.origin_dep_dt).toTimeString().slice(0, 5),
                                    date: `${new Date(segment.origin_dep_dt).getDate()} ${new Date(segment.origin_dep_dt).toLocaleString("default", { month: "short" })}`,
                                },
                                to: {
                                    station: segment.dest_name,
                                    code: segment.dest_code_iata,
                                    time: new Date(segment.dest_arr_dt).toTimeString().slice(0, 5),
                                    date: `${new Date(segment.dest_arr_dt).getDate()} ${new Date(segment.dest_arr_dt).toLocaleString("default", { month: "short" })}`,
                                },
                                duration: `${Math.floor(segment.duration_mins / 60)}hrs ${segment.duration_mins % 60}mins`,
                                stops: null,
                                price: segment.seat_avail_ui?.fare || 0,
                                bookUrl: segment.booking_link,
                                note: [segment.seat_avail_ui?.explanation].filter(Boolean),
                            },
                        };
                        append2.modes.push("flight");
                        append2.timelineSteps.push(tr);
                    } else {
                        const tr = {
                            type: "TrainCard",
                            icon: <img src="/icon1.svg" alt="Train Icon" style={{ width: 24, height: 24 }} />,
                            data: {
                                trainName: segment.train_name,
                                trainNumber: segment.train_num,
                                trainType: "Train",
                                from: {
                                    station: segment.origin_name,
                                    code: segment.origin_code,
                                    time: new Date(segment.origin_dep_dt).toTimeString().slice(0, 5),
                                    date: `${new Date(segment.origin_dep_dt).getDate()} ${new Date(segment.origin_dep_dt).toLocaleString("default", { month: "short" })}`,
                                },
                                to: {
                                    station: segment.dest_name,
                                    code: segment.dest_code,
                                    time: new Date(segment.dest_arr_dt).toTimeString().slice(0, 5),
                                    date: `${new Date(segment.dest_arr_dt).getDate()} ${new Date(segment.dest_arr_dt).toLocaleString("default", { month: "short" })}`,
                                },
                                duration: `${Math.floor(segment.duration_mins / 60)}hrs ${segment.duration_mins % 60}mins`,
                                stops: null,
                                price: segment.seat_avail_ui?.fare || 0,
                                bookUrl: segment.booking_link,
                                note: [segment.seat_avail_ui?.explanation].filter(Boolean),
                                info: segment.seat_avail_ui ? [
                                    {
                                        class: segment.seat_avail_ui.seat_class,
                                        Quota: segment.seat_avail_ui.quota || 'N/A',
                                        price: segment.seat_avail_ui.fare || 0,
                                        seats: segment.seat_avail_ui.avl || 'N/A',
                                        available: segment.seat_avail_ui.is_avail ? 1 : 0,
                                        refreshBody: {
                                            src: segment.origin_code,
                                            dest: segment.dest_code,
                                            pref_train_class: segment.seat_avail_ui.seat_class,
                                            train_num: segment.train_num,
                                            api_key: 'web_dev_1',
                                            quota: 'GN',
                                            get_avail_only: 1,
                                            date: segment.seat_avail_ui.date,
                                        }
                                    },
                                ] : [],
                            },
                        };

                        for (let k = 0; k < segment.seat_classes.length; k++) {
                            if (segment.seat_classes[k] == "GN" || segment.seat_classes[k] == segment.seat_avail_ui.seat_class) {
                                continue;
                            }
                            tr.data.info.push(
                                {
                                    class: segment.seat_classes[k],
                                    Quota: 'N/A',
                                    price: 'N/A',
                                    seats: 'N/A',
                                    available: -1,
                                    refreshBody: {
                                        src: segment.origin_code,
                                        dest: segment.dest_code,
                                        pref_train_class: segment.seat_classes[k],
                                        train_num: segment.train_num,
                                        api_key: 'web_dev_1',
                                        quota: 'GN',
                                        get_avail_only: 1,
                                        date: segment.seat_avail_ui.date,
                                    }
                                }
                            );
                        }
                        append2.modes.push("train");
                        append2.timelineSteps.push(tr);
                    }

                    if (cou && routeData.stops_data && routeData.stops_data.length > 0) {
                        routeData.stops_data.forEach((stop) => {
                            if (stop.stop_title) {
                                const tr = {
                                    type: "LocationComp",
                                    icon: <img src="/icon5.svg" alt="Location Icon" style={{ width: 37, height: 37 }} />,
                                    data: {
                                        name: stop.stop_title,
                                        description: [stop.commute_comment, stop.exp_time_avl_explanation].filter(Boolean),
                                        isLayover: true,
                                    },
                                };
                                append2.timelineSteps.push(tr);
                            }
                        });
                    }

                    cou = false;

                    if (segment.dest_comment_web) {
                        const tr = {
                            type: "LocationComp",
                            icon: <img src="/icon3.svg" alt="Location Icon" style={{ width: 24, height: 24 }} />,
                            data: {
                                name: segment.dest_comment_web_title,
                                description: [segment.dest_comment_web].filter(Boolean),
                                isLayover: false,
                            },
                        };
                        append2.timelineSteps.push(tr);
                    }
                }
                if (routeData.stops_data && routeData.stops_data.length > 0) {
                    for (const stop of routeData.stops_data) {
                        const val = stop.sch_time_avl_mins;
                        if (typeof val === 'number' && isFinite(val)) {
                            tDuration += val;
                        }
                    }
                }

                // Determine availability status for the whole route
                const allAvail = routeData.nodes.every(node => node?.segment?.seat_avail_ui?.is_avail === true);
                const allUnavail = routeData.nodes.every(node => node?.segment?.seat_avail_ui?.is_avail === false);
                if (allAvail) {
                    append2.availability = "Seats Available";
                    append2.toolTip = "Seats available on all segments of this route"
                } else if (allUnavail) {
                    append2.availability = "Seats Unavailable";
                    append2.toolTip = "Seats are not available on all segments of this route";
                } else {
                    append2.availability = "Seats Partially Available";
                    append2.toolTip = "Some segments have waitlisted or limited seat availability";
                }
            }

            append2.duration = `${Math.floor(tDuration / 60)}hrs ${tDuration % 60}mins`;
            append2.price = tPrice;
            processedTravelOptions.push(append2);
        }
        return processedTravelOptions;
    }, []);

    // Update individual refs when values change (will eventually be replaced by latestStateRef for onmessage)
    useEffect(() => {
        idTokenRef.current = idToken;
    }, [idToken]);

    useEffect(() => {
        fromFieldRef.current = fromField;
    }, [fromField]);

    useEffect(() => {
        connectionIdRef.current = connectionId;
    }, [connectionId]);

    useEffect(() => {
        firstMessageAfterLoginRef.current = firstMessageAfterLogin;
    }, [firstMessageAfterLogin]);

    useEffect(() => {
        oldFromFieldRef.current = oldFromField;
    }, [oldFromField]);

    useEffect(() => {
        lastFailedMessageRef.current = lastFailedMessage;
    }, [lastFailedMessage]);

    // New useEffect to keep latestStateRef updated with all relevant state/ref values
    useEffect(() => {
        latestStateRef.current = {
            idToken: idToken,
            fromField: fromField,
            connectionId: connectionId,
            firstMessageAfterLogin: firstMessageAfterLogin,
            oldFromField: oldFromField,
            lastFailedMessage: lastFailedMessage,
            pendingPaginationUpdate: pendingPaginationUpdate,
            wsUrl: wsUrl,
            apiKey: apiKey,
            // Include any other state/props that socket.onmessage needs up-to-date
            chatMessages: chatMessages,
            isWaitingForResponse: isWaitingForResponse,
            isLoading: isLoading,
            pendingMessages: pendingMessages,
        };
    }, [
        idToken, fromField, connectionId, firstMessageAfterLogin, oldFromField,
        lastFailedMessage, pendingPaginationUpdate, wsUrl, apiKey, chatMessages,
        isWaitingForResponse, isLoading, pendingMessages
    ]);

    // Monitor auth state and refresh token
    useEffect(() => {
        let unsubscribe;
        const setup = async () => {
            unsubscribe = onAuthStateChanged(auth, async (user) => {
                if (user) {
                    const token = await user.getIdToken(true);
                    setIdToken(token);
                    setUserProfile({
                        code: 2,
                        displayName: user.displayName || user.phoneNumber,
                        photoURL: user.photoURL || './profileDefault.png',
                        email: user.email,
                        phoneNumber: user.phoneNumber
                    });
                    // Use email/phone as mobnum
                    const userIdentifier = user.phoneNumber || user.email;
                    const old_mobnumTre = await getOrCreateUserId();
                    setFromField(isProduction ? `webbot_new:${userIdentifier}` : `webbot_new:${userIdentifier}`);
                    setOldFromField(isProduction ? `webbot_new:${old_mobnumTre}` : `webbot_new:${old_mobnumTre}`);
                    latestStateRef.current.fromField = isProduction ? `webbot_new:${userIdentifier}` : `webbot_new:${userIdentifier}`;
                    latestStateRef.current.oldFromField = isProduction ? `webbot_new:${old_mobnumTre}` : `webbot_new:${old_mobnumTre}`;
                    setUserId(userIdentifier);
                    userIdRef.current = userIdentifier;
                    setFirstMessageAfterLogin(true);

                    if (handleMigrationStatus.current == 1) {
                        handleMigrationStatus.current = 2;

                        // Call
                        const timestamp = Math.floor(Date.now() / 1000);
                        const message = {
                            //...lastFailedMessage,
                            headers: { Authorization: token },
                            body: {
                                search_stage: "production",
                                Body: "migration001",
                                From: latestStateRef.current.fromField,
                                Timestamp: timestamp,
                                old_mobnum: latestStateRef.current.oldFromField,
                                // ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {})
                            },
                        };
                        socketRef.current.send(JSON.stringify(message));

                        console.log("migration001 after login", JSON.stringify(message));

                    }

                    // Fetch history with user info if not already loaded
                    if (!historyLoadedRef.current) {
                        fetchChatHistory(false, null, token, isProduction ? `webbot_new:${userIdentifier}` : `webbot_new:${userIdentifier}`);
                    }
                    // Token refresh interval
                    const interval = setInterval(async () => {
                        const refreshedToken = await user.getIdToken(true);
                        setIdToken(refreshedToken);
                    }, 50 * 60 * 1000);
                    return () => clearInterval(interval);
                } else {

                    handleMigrationStatus.current = 1;

                    setIdToken(null);
                    setUserProfile({ code: 3 });
                    // If not logged in, use generated userId as mobnum
                    const initialUserId = await getOrCreateUserId();
                    setFromField(isProduction ? `webbot_new:${initialUserId}` : `webbot_new:${initialUserId}`);
                    setOldFromField(isProduction ? `webbot_new:${initialUserId}` : `webbot_new:${initialUserId}`);
                    latestStateRef.current.fromField = isProduction ? `webbot_new:${initialUserId}` : `webbot_new:${initialUserId}`;
                    latestStateRef.current.oldFromField = isProduction ? `webbot_new:${initialUserId}` : `webbot_new:${initialUserId}`;
                    setUserId(initialUserId);
                    if (!historyLoadedRef.current) {
                        fetchChatHistory(false, null, null, isProduction ? `webbot_new:${initialUserId}` : `webbot_new:${initialUserId}`);
                    }
                }
            });
        };
        setup();
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [historyLoaded, chatMessages, hasMoreHistory, navigate]);

    // Initialize and cleanup RecaptchaVerifier
    // useEffect(() => {
    //     let recaptchaInstance = null;

    //     if (isModalOpen && !recaptchaVerifierRef.current && !isRecaptchaInitialized) {
    //         console.log("Initializing RecaptchaVerifier...");

    //         // Ensure the container exists
    //         const container = document.getElementById('recaptcha-container');
    //         if (!container) {
    //             console.error("reCAPTCHA container not found");
    //             return;
    //         }

    //         try {
    //             recaptchaInstance = new RecaptchaVerifier(auth, "recaptcha-container", {
    //                 size: "invisible",
    //                 callback: () => {
    //                     console.log("reCAPTCHA verified");
    //                 },
    //             });

    //             recaptchaVerifierRef.current = recaptchaInstance;
    //             console.log("RecaptchaVerifier initialized");
    //             setIsRecaptchaInitialized(true);
    //         } catch (error) {
    //             console.error("Error initializing RecaptchaVerifier:", error);
    //         }
    //     }

    //     // Cleanup function
    //     return () => {
    //         if (recaptchaVerifierRef.current) {
    //             try {
    //                 recaptchaVerifierRef.current.clear();
    //                 recaptchaVerifierRef.current = null;
    //                 setIsRecaptchaInitialized(false);
    //                 console.log("RecaptchaVerifier cleaned up");
    //             } catch (error) {
    //                 console.error(" Error cleaning up RecaptchaVerifier:", error);
    //             }
    //         }
    //     };
    // }, [isModalOpen, isRecaptchaInitialized]);

    const resetInactivityTimeout = () => {
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
        }
        inactivityTimeoutRef.current = setTimeout(() => {
            if (socketRef.current?.readyState === WebSocket.OPEN) {
                socketRef.current.close();
                console.log("WebSocket closed due to inactivity");
            }
        }, 300 * 1000);
    };

    useEffect(() => {
        if (chatHistoryRef.current && shouldScrollToBottom) {
            chatHistoryRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            if (chatHistoryRef2.current) {
                chatHistoryRef2.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
            setShouldScrollToBottom(false);
        }
    }, [chatMessages, shouldScrollToBottom]);

    // Main WebSocket connection logic
    useEffect(() => {
        console.log("Initializing WebSocket connection...");
        let reconnectAttempts = 0;
        const maxReconnectAttempts = 1;
        let reconnectTimeout;
        let isComponentMounted = true;

        const connectWebSocket = () => {
            if (!isComponentMounted || (socketRef.current && socketRef.current.readyState === WebSocket.OPEN)) {
                return;
            }

            console.log("Initiating WebSocket connection...");
            const socket = new WebSocket(latestStateRef.current.wsUrl);
            socketRef.current = socket;

            socket.onopen = () => {
                console.log("WebSocket connected successfully");
                setConnectionError(null);
                reconnectAttempts = 0;
                setIsInitializing(false);

                // Handle initial connection scenarios
                if (latestStateRef.current.lastFailedMessage) {
                    console.log("Resending message that triggered 401:", latestStateRef.current.lastFailedMessage);
                    socket.send(
                        JSON.stringify({
                            ...latestStateRef.current.lastFailedMessage,
                            headers: latestStateRef.current.idToken ? { Authorization: latestStateRef.current.idToken } : {},
                            body: {
                                ...latestStateRef.current.lastFailedMessage.body,
                                search_stage: "production",
                                From: latestStateRef.current.fromField,
                                Timestamp: Math.floor(Date.now() / 1000),
                                ...(latestStateRef.current.firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {}),
                            },
                        })
                    );
                    setLastFailedMessage(null);
                    setFirstMessageAfterLogin(false);
                } else if (showWelcomeMessage && isFirstConnection.current && false) {
                    //alert("calling welcome message two.");
                    const message = {
                        action: "conversation",
                        headers: latestStateRef.current.idToken ? { Authorization: latestStateRef.current.idToken } : {},
                        body: {
                            search_stage: "production",
                            From: latestStateRef.current.fromField,
                            msg_src: "web",
                            api_key: latestStateRef.current.apiKey,
                            Timestamp: Math.floor(Date.now() / 1000),
                            ...(latestStateRef.current.firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {}),
                        },
                    };
                    lastMessageRef.current = message;
                    console.log("Sending initial welcome message", JSON.stringify(message, null, 2));
                    socket.send(JSON.stringify(message));
                    setFirstMessageAfterLogin(false);
                    isFirstConnection.current = false;
                }
            };

            socket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                console.log("Message from server:", JSON.stringify(data, null, 2));
                setShowWelcomeMessage(false);

                // Handle thinking state from WebSocket
                if (data.thinking_title) {
                    console.log("Caught thinking metadata:", data.thinking_title, data.thinking_desc);
                    setThinkingData({
                        thinking_title: data.thinking_title,
                        thinking_desc: data.thinking_desc || ""
                    });
                }

                // If actual content arrives, clear thinking state
                // Only clear if no thinking_title is present in the current message
                if ((data.data || (data.paginated_results && data.paginated_results.length > 0)) && !data.thinking_title) {
                    setThinkingData(null);
                }

                // Clear heroInput from location state after bot response to hero message
                if (location.state?.fromHero && location.state.heroInput) {
                    navigate(location.pathname, { replace: true, state: {} });
                }

                if (data.message === "Endpoint request timed out") return;

                if (data.connectionId) {
                    setConnectionId(data.connectionId);
                    console.log("Connection ID received:", data.connectionId);
                }

                // Handle initial connection response
                if (isInitializing) {
                    setIsInitializing(false);
                    setConnectionAttempts(0);
                }

                if (data.message === "migration001 completed!" && handleMigrationStatus.current == 2) {
                    handleMigrationStatus.current = 0;

                    if (!lastFailedHistoryParams) {
                        setTimeout(async () => {
                            //alert("calling history");

                            const idUser = userIdRef.current;
                            fetchChatHistory(false, null, idToken, isProduction ? `webbot_new:${idUser}` : `webbot_new:${idUser}`,
                                () => {
                                    console.log("TIme 1");
                                    setChatMessages([]);

                                    fetchChatHistory(false, null, idToken, isProduction ? `webbot_new:${idUser}` : `webbot_new:${idUser}`,
                                        () => {
                                            console.log("Time 2");
                                            if (lastFailedMessage && socketRef.current?.readyState === WebSocket.OPEN) {

                                                //alert("came in");

                                                setChatMessages((prev) => [
                                                    ...prev,
                                                    lastMessageRef.current,
                                                ]);

                                                console.log("Resending last failed message...", JSON.stringify(lastFailedMessage, null, 2));
                                                const timestamp = Math.floor(Date.now() / 1000);
                                                const message = {
                                                    ...lastFailedMessage,
                                                    headers: { Authorization: idToken },
                                                    body: {
                                                        ...lastFailedMessage.body,
                                                        search_stage: "production",
                                                        From: fromField,
                                                        Timestamp: timestamp,
                                                        ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {})
                                                    },
                                                };
                                                socketRef.current.send(JSON.stringify(message));
                                                setLastFailedMessage(null);
                                                setFirstMessageAfterLogin(false);
                                                setIsWaitingForResponse(true);
                                                setIsLoading(true);
                                            }

                                        }
                                    );
                                }
                            );
                        }, 0);
                    }

                    return;
                }

                if (data.status === 401) {
                    // Store the last message that triggered the 401
                    console.log("lastMessage:", lastMessageRef.current);
                    setLastFailedMessage(lastMessageRef.current);
                    lastMessageRef.current = null;
                    setOldFromField(latestStateRef.current.fromField);
                    latestStateRef.current.oldFromField = latestStateRef.current.fromField;

                    // Reset all loaders and waiting states
                    setIsLoading(false);
                    setIsWaitingForResponse(false);
                    setThinkingData(null);
                    setPendingMessages(new Map());

                    const updateId = latestStateRef.current.pendingPaginationUpdate;
                    if (updateId) {
                        setChatMessages((prevMessages) => {
                            return prevMessages.map((msg) => {
                                if (msg.sender === 'bot' && msg.id === updateId) {
                                    return { ...msg, isPaginating: false };
                                }
                                return msg;
                            });
                        });
                        setPendingPaginationUpdate(null);
                        latestStateRef.current.pendingPaginationUpdate = null;
                    }

                    if (!auth.currentUser && !isModalOpen) setIsModalOpen(true);
                    console.log("Unauthorized: Opening login modal");
                    return;
                }

                setCanShowTyping(true);

                // Prioritize updating an existing message if a pagination request is pending
                if (latestStateRef.current.pendingPaginationUpdate && data.paginated_results && data.paginated_results.length > 0) {
                    setShouldScrollToBottom(false);
                    console.log("Attempting to update pending pagination message with user_msg_ts:", latestStateRef.current.pendingPaginationUpdate);
                    const updateId = latestStateRef.current.pendingPaginationUpdate;
                    setChatMessages((prevMessages) => {
                        return prevMessages.map((msg) => {
                            //console.warn(msg.id,updateId);
                            if (msg.sender == 'bot' && msg.id === updateId) {
                                console.log("inside tree");
                                // Process the new paginated results
                                const newPaginatedResults = processPaginatedResults(data.paginated_results);
                                const existingResults = msg.paginated_results || [];

                                // Combine existing and new results, avoiding duplicates
                                const updatedResults = [...existingResults];
                                newPaginatedResults.forEach(newResult => {
                                    const isDuplicate = existingResults.some(existing =>
                                        existing.departure?.time === newResult.departure?.time &&
                                        existing.arrival?.time === newResult.arrival?.time &&
                                        existing.price === newResult.price
                                    );
                                    if (!isDuplicate) {
                                        updatedResults.push(newResult);
                                    }
                                });

                                // Update selected travel option if it exists in the new data
                                const currentSelected = selectedTravelOptions[msg.id];
                                if (currentSelected) {
                                    const updatedSelected = updatedResults.find(item =>
                                        item.departure?.time === currentSelected.departure?.time &&
                                        item.arrival?.time === currentSelected.arrival?.time &&
                                        item.price === currentSelected.price
                                    );
                                    if (updatedSelected) {
                                        setSelectedTravelOptions(prev => ({
                                            ...prev,
                                            [msg.id]: updatedSelected
                                        }));
                                    }
                                }

                                let updatedShowMoreData = null;
                                if (data.quick_replies) {
                                    Object.entries(data.quick_replies).forEach(([key, value]) => {
                                        if (key.includes("More routes")) {
                                            updatedShowMoreData = { key: key, value: value };
                                        }
                                    });
                                }

                                return {
                                    ...msg,
                                    paginated_results: updatedResults,
                                    showMoreData: updatedShowMoreData,
                                    quick_replies: data.quick_replies || null,
                                    isPaginating: false,
                                };
                            }
                            return msg;
                        });
                    });

                    // Clear the pending pagination update
                    setPendingPaginationUpdate(null);
                    latestStateRef.current.pendingPaginationUpdate = null;
                    setIsWaitingForResponse(false);
                    setIsLoading(false);
                    console.log("Pagination update handled and pendingPaginationUpdate cleared.");
                } else if (data.data && data.data !== 'migration001') {
                    if (data.thinking_title) {
                        // If thinking metadata is present, we skip adding this as a chat message
                        // to avoid "double show" with the thinking component.
                        setShouldScrollToBottom(true);
                        setIsWaitingForResponse(true);
                        setIsLoading(false);
                    } else {
                        const newMessage = {
                            sender: "bot",
                            text: data.data,
                            timestamp: new Date(),
                            user_msg_ts: (data.user_msg_ts === "None" ? "" : data.user_msg_ts) || "",
                            paginated_results: null,
                            quick_replies: null,
                            showMoreData: null,
                            id: Date.now().toString(),
                            isPaginating: false, // Initial state for new messages
                        };

                        if (data.paginated_results && data.paginated_results.length > 0) {
                            newMessage.paginated_results = processPaginatedResults(data.paginated_results);
                        }

                        // Assign quick replies to the new message if present
                        if (data.quick_replies && typeof data.quick_replies === "object" && Object.keys(data.quick_replies).length > 0) {
                            Object.entries(data.quick_replies).forEach(([key, value]) => {
                                if (key.includes("More routes")) {
                                    newMessage.showMoreData = { key: key, value: value };
                                }
                            });
                            newMessage.quick_replies = data.quick_replies;
                            console.log("Quick replies assigned to message:", data.quick_replies);
                        } else {
                            newMessage.quick_replies = null; // Ensure quick_replies is explicitly null if no replies are present
                        }

                        newMessage.isHistory = false;
                        newMessage.isTypingDone = false;
                        //setCanShowTyping(true);

                        setChatMessages((prev) => {
                            const cleared = prev.map(msg =>
                                msg.quick_replies ? { ...msg, quick_replies: null } : msg
                            );
                            console.log("Adding new bot message to chat. user_msg_ts:", newMessage.user_msg_ts);
                            return [...prev, newMessage];
                        });
                        setBotResponseCount(prev => prev + 1);
                        setShouldScrollToBottom(true);
                        if (data.more_replies_await !== true) {
                            setIsWaitingForResponse(false);
                        }
                        setIsLoading(false);
                    }

                } else {
                    console.log("Incoming message does not contain data or recognized pagination context.", data);
                    //setIsWaitingForResponse(false);
                    setIsLoading(false);
                }

                if (data.user_msg_ts) {
                    setPendingMessages((prev) => {
                        const newPending = new Map(prev);
                        if (data.more_replies_await === false) {
                            newPending.delete(data.user_msg_ts);
                        }
                        return newPending;
                    });
                }

                if (typeof data.more_replies_await !== "undefined") {
                    setIsMoreRepliesLoading(!!data.more_replies_await);
                }
            };

            socket.onerror = (error) => {
                console.error("❌ WebSocket error:", error);
                setConnectionError("Failed to connect to the server. Please check your network or try again later.");
                if (isInitializing) {
                    setConnectionAttempts(prev => {
                        const newAttempts = prev + 1;
                        if (newAttempts >= MAX_CONNECTION_ATTEMPTS) {
                            setConnectionError("Unable to establish connection after multiple attempts. Please refresh the page.");
                            setIsInitializing(false);
                        }
                        return newAttempts;
                    });
                }
            };

            socket.onclose = (event) => {
                console.log("WebSocket closed. Code:", event.code, "Reason:", event.reason);

                if (isComponentMounted && reconnectAttempts < maxReconnectAttempts) {
                    reconnectAttempts++;
                    const delay = Math.pow(2, reconnectAttempts) * 1000;
                    reconnectTimeout = setTimeout(connectWebSocket, delay);
                    console.log(`Attempting to reconnect (${reconnectAttempts}/${maxReconnectAttempts})...`);
                } else if (reconnectAttempts >= maxReconnectAttempts) {
                    console.error("Max reconnect attempts reached");
                    setConnectionError("Unable to connect to the server after multiple attempts. Please try again later.");
                    setIsInitializing(false);
                }
            };
        };

        connectWebSocket();

        return () => {
            isComponentMounted = false;
            clearTimeout(reconnectTimeout);
            if (inactivityTimeoutRef.current) {
                clearTimeout(inactivityTimeoutRef.current);
            }
            if (socketRef.current) {
                socketRef.current.close();
                socketRef.current = null;
            }
        };
    }, [wsUrl, apiKey, processPaginatedResults]);

    // Keep only one useEffect for fetchChatHistory
    useEffect(() => {
        // This useEffect is now primarily for fetching older messages (pagination)
        // and for the initial hero message flow if applicable.
        // The main initial history fetch is now triggered from onAuthStateChanged.
    }, [idToken, fromField]);

    // Add hero message logic in a separate useEffect
    useEffect(() => {
        if (
            location.state?.fromHero &&
            location.state.heroInput &&
            !heroMessageSentRef.current &&
            !isInitializing &&
            historyLoaded // <--- use this instead of chatMessages.length > 0
        ) {
            heroMessageSentRef.current = true; // Set before sending to avoid race
            if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
                // Wait and retry if socket not ready
                const retry = setTimeout(() => {
                    heroMessageSentRef.current = false;
                }, 2000);
                return () => clearTimeout(retry);
            }
            const timestamp = Math.floor(Date.now() / 1000);
            //alert("tre 1");
            const message = {
                action: "conversation",
                headers: idToken ? { Authorization: idToken } : {},
                body: {
                    search_stage: "production",
                    From: fromField,
                    Body: location.state.heroInput,
                    msg_src: "web",
                    connection_id: connectionId,
                    api_key: apiKey,
                    Timestamp: timestamp,
                    ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField ? latestStateRef.current.oldFromField : oldFromField } : {}),
                },
            };
            lastMessageRef.current = message;
            socketRef.current.send(JSON.stringify(message));
            setChatMessages((prev) => [
                ...prev,
                { sender: "user", text: location.state.heroInput, timestamp: new Date(), user_msg_ts: timestamp.toString() },
            ]);
            setShouldScrollToBottom(true);
            setPendingMessages((prev) => new Map(prev).set(timestamp.toString(), true));
            setShowWelcome(false);
            setIsWaitingForResponse(true);
            waitForResRef.current = true;
            setIsLoading(true);
            setThinkingData(null);
            setInputMessage("");
            setFirstMessageAfterLogin(false);
            setHeroMessageSent(true);
            // Removed navigate here to allow loader to show until bot response
        }
    }, [location, idToken, fromField, connectionId, apiKey, firstMessageAfterLogin, oldFromField, isInitializing, historyLoaded, navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!inputMessage.trim() || isWaitingForResponse) return;

        const timestamp = Math.floor(Date.now() / 1000);
        if (socketRef.current?.readyState === WebSocket.OPEN) {
            //alert("tre 2");
            const message = {
                action: "conversation",
                headers: idToken ? { Authorization: idToken } : {},
                body: {
                    search_stage: "production",
                    From: fromField,
                    Body: inputMessage,
                    msg_src: "web",
                    connection_id: connectionId,
                    api_key: apiKey,
                    Timestamp: timestamp,
                    ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {}),
                },
            };
            console.log(message);
            socketRef.current.send(JSON.stringify(message));
            const userMess = { sender: "user", text: inputMessage, timestamp: new Date(), user_msg_ts: timestamp.toString() };
            setChatMessages((prev) => [
                ...prev,
                userMess,
            ]);

            setLastUserMessage(userMess);
            lastUserMessageRef.current = userMess;

            setLastMessage(message);
            lastMessageRef.current = message;
            setShouldScrollToBottom(true);
            setPendingMessages((prev) => new Map(prev).set(timestamp.toString(), true));
            setIsWaitingForResponse(true);
            setIsLoading(true);
            setThinkingData(null);
            setBotResponseCount(0);
            setInputMessage("");
            setShowWelcome(false);
            setFirstMessageAfterLogin(false);
        } else {
            console.error("WebSocket not connected");
            setConnectionError("Cannot send message: WebSocket is not connected.");
            window.location.reload();
        }
    };

    const handleSubmit2 = (e) => {
        if (!inputMessage.trim() || isWaitingForResponse) return;

        const timestamp = Math.floor(Date.now() / 1000);
        if (socketRef.current?.readyState === WebSocket.OPEN) {
            //alert("tre 4");
            const message = {
                action: "conversation",
                headers: idToken ? { Authorization: idToken } : {},
                body: {
                    search_stage: "production",
                    From: fromField,
                    Body: inputMessage,
                    msg_src: "web",
                    connection_id: connectionId,
                    api_key: apiKey,
                    Timestamp: timestamp,
                    ...(firstMessageAfterLogin ? { old_mobnum: oldFromField } : {}),
                },
            };
            socketRef.current.send(JSON.stringify(message));
            setChatMessages((prev) => {

                const cleared = prev.map(msg =>
                    msg.quick_replies ? { ...msg, quick_replies: null } : msg
                );

                return [
                    ...cleared,
                    { sender: "user", text: inputMessage, timestamp: new Date(), user_msg_ts: timestamp.toString() },
                ]
            });
            setShouldScrollToBottom(true);
            setPendingMessages((prev) => new Map(prev).set(timestamp.toString(), true));
            setIsWaitingForResponse(true);
            setIsLoading(true);
            setThinkingData(null);
            setBotResponseCount(0);
            setInputMessage("");
            setShowWelcome(false);
            setFirstMessageAfterLogin(false);
        } else {
            console.error("WebSocket not connected");
            setConnectionError("Cannot send message: WebSocket is not connected.");
            window.location.reload();
        }
    }

    const handleUserReply = (text, id, userMsgTsToClear) => {
        console.log("tree");
        const timestamp = Math.floor(Date.now() / 1000);
        if (socketRef.current?.readyState === WebSocket.OPEN && !isWaitingForResponse) {
            //alert("tre 5");
            const message = {
                action: "conversation",
                headers: idToken ? { Authorization: idToken } : {},
                body: {
                    search_stage: "production",
                    From: fromField,
                    Body: text,
                    msg_src: "web",
                    connection_id: connectionId,
                    api_key: apiKey,
                    ButtonPayload: id,
                    Timestamp: timestamp,
                    ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {}),
                },
            };
            socketRef.current.send(JSON.stringify(message));

            const userMess = {
                sender: "user",
                text,
                timestamp: new Date(),
                user_msg_ts: timestamp.toString()
            };

            setChatMessages((prev) => {
                return prev.map((msg) => {
                    if (msg.sender === "bot" && msg.user_msg_ts === userMsgTsToClear) {
                        return {
                            ...msg,
                            //quick_replies: null
                        };
                    }
                    return msg;
                }).concat([userMess]);
            });

            setLastUserMessage(userMess);
            lastUserMessageRef.current = userMess;

            lastMessageRef.current = message;
            console.log("lastMessage tree:", lastMessageRef.current);
            setShouldScrollToBottom(true);
            setPendingMessages((prev) => new Map(prev).set(timestamp.toString(), true));
            setIsWaitingForResponse(true);
            setIsLoading(true);
            setThinkingData(null);
            setBotResponseCount(0);
            setShowWelcome(false);
            setFirstMessageAfterLogin(false);
        } else {
            console.error("WebSocket not connected or waiting for response");
            setConnectionError("Cannot send quick reply: not connected or waiting for response.");
            window.location.reload();
        }
    };

    const handlePaginationRequest = (text, id, originalBotUserMsgTs) => {
        //console.log("Sending pagination request for original user msg ts:", originalBotUserMsgTs);
        console.log("update tree", originalBotUserMsgTs);
        const timestamp = Math.floor(Date.now() / 1000);
        if (socketRef.current?.readyState === WebSocket.OPEN) {
            //alert("tre 6");
            const message = {
                action: "conversation",
                headers: idToken ? { Authorization: idToken } : {},
                body: {
                    search_stage: "production",
                    From: fromField,
                    Body: text,
                    msg_src: "web",
                    connection_id: connectionId,
                    api_key: apiKey,
                    ButtonPayload: id,
                    Timestamp: timestamp,
                    ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {}),
                },
            };
            socketRef.current.send(JSON.stringify(message));

            // Set the specific message to be paginating
            setChatMessages(prev => prev.map(msg => {
                if (msg.sender === "bot" && msg.id === originalBotUserMsgTs) {
                    return { ...msg, isPaginating: true };
                }
                return msg;
            }));

            lastMessageRef.current = null;

            setPendingMessages((prev) => new Map(prev).set(timestamp.toString(), true));
            setShowWelcome(false);
            setFirstMessageAfterLogin(false);

            // Set the user_msg_ts of the message awaiting pagination update
            // console.log("Debug: originalBotUserMsgTs inside handlePaginationRequest:", originalBotUserMsgTs);
            // console.log("Debug: (originalBotUserMsgTs === \"None\"):", (originalBotUserMsgTs === "None"));
            const paginationId = (originalBotUserMsgTs === "None") ? Date.now().toString() : originalBotUserMsgTs;
            latestStateRef.current.pendingPaginationUpdate = paginationId;
            setPendingPaginationUpdate(paginationId); // Also update state for re-renders
            //console.log("pendingPaginationUpdateRef.current after setting:", latestStateRef.current.pendingPaginationUpdate);

        } else {
            console.error("WebSocket not connected or waiting for response");
            setConnectionError("Cannot send pagination request: not connected or waiting for response.");
            window.location.reload();
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();
        if (!mobileNumber.trim()) {
            alert("Please enter a mobile number");
            return;
        }

        if (isLoginLoading) {
            console.log("Login already in progress, ignoring request");
            return;
        }

        try {
            const phoneNumber = mobileNumber.startsWith("+") ? mobileNumber : `+${mobileNumber}`;

            // Validate phone number format
            if (!/^\+[1-9]\d{1,14}$/.test(phoneNumber)) {
                alert("Please enter a valid phone number with country code (e.g., +919876543210)");
                return;
            }

            // Show loading state
            setIsLoginLoading(true);
            setIsLoading(true);

            // Always clear any previous reCAPTCHA instance before creating a new one
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                } catch (e) {
                    console.log("Error clearing previous reCAPTCHA:", e);
                }
                recaptchaVerifierRef.current = null;
            }

            // Generate a new unique id for the container
            const newId = `recaptcha-container-${Date.now()}`;
            setRecaptchaContainerId(newId);

            // Wait for the DOM to update
            await new Promise(resolve => setTimeout(resolve, 100));

            // Check if container exists
            const container = document.getElementById(newId);
            if (!container) {
                throw new Error("reCAPTCHA container not found");
            }

            recaptchaVerifierRef.current = new RecaptchaVerifier(auth, newId, {
                size: "invisible",
                callback: () => {
                    console.log("reCAPTCHA verified");
                },
            });

            console.log("Sending OTP to:", phoneNumber);
            const confirmation = await signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifierRef.current);
            setConfirmationResult(confirmation);
            setOtpSent(true);
            console.log("OTP sent successfully to", phoneNumber);
            alert("OTP sent successfully! Please check your phone.");
        } catch (error) {
            console.error("Error sending OTP:", error);

            // Handle specific error cases
            if (error.code === 'auth/network-request-failed') {
                alert("Network error: Please check your internet connection and try again.");
            } else if (error.code === 'auth/too-many-requests') {
                alert("Too many attempts. Please try again after some time or use Google Sign-in instead.");
            } else if (error.code === 'auth/invalid-phone-number') {
                alert("Invalid phone number format. Please enter a valid phone number with country code (e.g., +919876543210)");
            } else if (error.code === 'auth/quota-exceeded') {
                alert("Phone authentication quota exceeded. Please try again later or use Google Sign-in.");
            } else if (error.code === 'auth/argument-error') {
                alert("Error with reCAPTCHA verification. Please try again.");
            } else if (error.code === 'auth/captcha-check-failed') {
                alert("reCAPTCHA verification failed. Please try again.");
            } else if (error.code === 'auth/operation-not-allowed') {
                alert("Phone authentication is not enabled. Please use Google Sign-in instead.");
            } else {
                alert(`Failed to send OTP: ${error.message || 'Unknown error'}. Please try again.`);
            }

            // Reset reCAPTCHA on error
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                } catch (e) {
                    console.log("Error clearing reCAPTCHA:", e);
                }
                recaptchaVerifierRef.current = null;
            }
            setIsRecaptchaInitialized(false);
        } finally {
            setIsLoginLoading(false);
            setIsLoading(false);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        if (!otp.trim()) {
            alert("Please enter the OTP");
            return;
        }

        if (isLoginLoading) {
            console.log("Login already in progress, ignoring request");
            return;
        }

        if (!confirmationResult) {
            alert("No OTP confirmation found. Please send OTP again.");
            return;
        }

        try {
            setIsLoginLoading(true);
            setIsLoading(true);

            console.log("Verifying OTP...");
            const result = await confirmationResult.confirm(otp);
            const user = result.user;

            console.log("Getting ID token...");
            const token = await user.getIdToken(true); // Force refresh token

            if (!token) {
                throw new Error("Failed to get authentication token");
            }

            console.log("Phone auth successful, setting user profile...");

            // Set user profile first
            setUserProfile({
                code: 2,
                displayName: user.displayName || user.phoneNumber,
                photoURL: user.photoURL || './profileDefault.png',
                email: user.email,
                phoneNumber: user.phoneNumber
            });

            // Set token and close modal
            setIdToken(token);
            setIsModalOpen(false);
            setMobileNumber("");
            setOtp("");
            setOtpSent(false);
            setConfirmationResult(null);

            // --- Reset guest history and fetch logged-in user history ---
            const userIdentifier = user.phoneNumber || user.email;
            setHistoryLoaded(false);
            setChatMessages([]);
            // Only fetch if not retrying failed history
            // if (!lastFailedHistoryParams) {
            //     setTimeout(() => {
            //         fetchChatHistory(false, null, token, isProduction ? `webbot_new:${userIdentifier}` : `webbot_new:${userIdentifier}`,
            //             () => {
            //                 if (lastFailedMessage && socketRef.current?.readyState === WebSocket.OPEN) {
            //                     console.log("Resending last failed message...", JSON.stringify(lastFailedMessage, null, 2));

            //                     setChatMessages((prev) => [
            //                         ...prev,
            //                         lastMessageRef.current,
            //                     ]);


            //                     const timestamp = Math.floor(Date.now() / 1000);
            //                     const message = {
            //                         ...lastFailedMessage,
            //                         headers: { Authorization: token },
            //                         body: {
            //                             ...lastFailedMessage.body,
            //                             From: fromField,
            //                             Timestamp: timestamp,
            //                             ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {})
            //                         },
            //                     };
            //                     socketRef.current.send(JSON.stringify(message));
            //                     setLastFailedMessage(null);
            //                     setFirstMessageAfterLogin(false);
            //                     setIsWaitingForResponse(true);
            //                     setIsLoading(true);
            //                 }
            //             }
            //         );
            //     }, 0);
            // }

            console.log("Phone auth successful, idToken:", token);

            // Retry failed chat history API if needed
            if (lastFailedHistoryParams) {
                console.log("Retrying failed chat history...");
                await fetchChatHistory(lastFailedHistoryParams.isLoadingOlder, lastFailedHistoryParams.lastTimestamp);
                setLastFailedHistoryParams(null);
            }

            console.log("Login process completed successfully");
        } catch (error) {
            console.error("Error verifying OTP:", error);

            if (error.code === 'auth/invalid-verification-code') {
                alert("Invalid OTP. Please check the code and try again.");
            } else if (error.code === 'auth/invalid-verification-id') {
                alert("OTP session expired. Please send OTP again.");
                setOtpSent(false);
                setConfirmationResult(null);
            } else if (error.code === 'auth/network-request-failed') {
                alert("Network error: Please check your internet connection and try again.");
            } else {
                alert(`Failed to verify OTP: ${error.message || 'Unknown error'}. Please try again.`);
            }
        } finally {
            setIsLoginLoading(false);
            setIsLoading(false);
        }
    };

    const handleGoogleLogin = async () => {
        if (isLoginLoading) {
            console.log("Login already in progress, ignoring request");
            return;
        }

        try {
            setIsLoginLoading(true);
            setIsLoading(true);

            console.log("Starting Google login...");
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            console.log("Getting ID token...");
            const token = await user.getIdToken(true); // Force refresh token

            if (!token) {
                throw new Error("Failed to get authentication token");
            }

            console.log("Google auth successful, setting user profile...");

            // Set user profile first
            setUserProfile({
                code: 2,
                displayName: user.displayName || user.phoneNumber,
                photoURL: user.photoURL || './profileDefault.png',
                email: user.email,
                phoneNumber: user.phoneNumber
            });

            // Set token and close modal
            setIdToken(token);
            setIsModalOpen(false);

            // --- Reset guest history and fetch logged-in user history ---
            const userIdentifier = user.phoneNumber || user.email;
            setHistoryLoaded(false);
            setChatMessages([]);
            // Only fetch if not retrying failed history
            // if (!lastFailedHistoryParams) {
            //     setTimeout(() => {
            //         //alert("calling history");
            //         console.log(new Date());
            //         fetchChatHistory(false, null, token, isProduction ? `webbot_new:${userIdentifier}` : `webbot_new:${userIdentifier}`,
            //             () => {
            //                 if (lastFailedMessage && socketRef.current?.readyState === WebSocket.OPEN) {

            //                     //alert("came in");

            //                     setChatMessages((prev) => [
            //                         ...prev,
            //                         lastMessageRef.current,
            //                     ]);

            //                     console.log("Resending last failed message...", JSON.stringify(lastFailedMessage, null, 2));
            //                     const timestamp = Math.floor(Date.now() / 1000);
            //                     const message = {
            //                         ...lastFailedMessage,
            //                         headers: { Authorization: token },
            //                         body: {
            //                             ...lastFailedMessage.body,
            //                             From: fromField,
            //                             Timestamp: timestamp,
            //                             ...(firstMessageAfterLogin ? { old_mobnum: latestStateRef.current.oldFromField } : {})
            //                         },
            //                     };
            //                     socketRef.current.send(JSON.stringify(message));
            //                     setLastFailedMessage(null);
            //                     setFirstMessageAfterLogin(false);
            //                     setIsWaitingForResponse(true);
            //                     setIsLoading(true);
            //                 }
            //             }
            //         );
            //     }, 0);
            // }

            console.log("Google auth successful, token:", token);

            // Retry failed chat history API if needed
            if (lastFailedHistoryParams) {
                console.log("Retrying failed chat history...");
                await fetchChatHistory(lastFailedHistoryParams.isLoadingOlder, lastFailedHistoryParams.lastTimestamp);
                setLastFailedHistoryParams(null);
            }

            console.log("Google login process completed successfully");
        } catch (error) {
            console.error("Error with Google login:", error);

            if (error.code === 'auth/network-request-failed') {
                alert("Network error: Please check your internet connection and try again.");
            } else if (error.code === 'auth/popup-closed-by-user') {
                alert("Login cancelled. Please try again.");
            } else if (error.code === 'auth/popup-blocked') {
                alert("Popup blocked by browser. Please allow popups and try again.");
            } else if (error.code === 'auth/cancelled-popup-request') {
                alert("Login cancelled. Please try again.");
            } else {
                alert(`Failed to sign in with Google: ${error.message || 'Unknown error'}. Please try again.`);
            }
        } finally {
            setIsLoginLoading(false);
            setIsLoading(false);
        }
    };

    const showLoader = isLoading && pendingMessages.size > 0;

    const groupedMessages = chatMessages.reduce((acc, msg, index) => {
        const prevMsg = chatMessages[index - 1];
        const isNewGroup = !prevMsg || prevMsg.sender !== msg.sender;
        if (isNewGroup) {
            acc.push([]);
        }
        acc[acc.length - 1].push(msg);
        return acc;
    }, []);

    // Function to handle travel option selection
    const handleTravelOptionSelect = (item, messageId) => {
        setSelectedTravelOptions(prev => ({
            ...prev,
            [messageId]: item
        }));
    };

    function formatBold(str) {
        if (!str) return "";
        // First convert URLs to clickable links
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const textWithLinks = str.replace(urlRegex, url => `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #0066cc; text-decoration: underline;">${url}</a>`);
        // Then handle bold formatting
        return textWithLinks.replace(/\*([^*]+)\*/g, '<b>$1</b>');
    }

    // Function to fetch chat history
    const fetchChatHistory = async (isLoadingOlder = false, lastTimestamp = null, authToken = null, mobnum = null, callback = () => { }) => {
        //alert("fetchChatHistory");
        // Prevent duplicate loads
        if (isLoadingOlder && isLoadingOlderMessages) return;
        if (!isLoadingOlder && isLoadingHistory) return;
        // --- REMOVE THIS LINE TO ALWAYS ALLOW FETCH AFTER LOGIN ---
        // if (!isLoadingOlder && historyLoadedRef.current) return; // Prevent duplicate initial loads

        console.log("Time 3");

        // Use refs to get current values
        const currentIdToken = authToken || idTokenRef.current || idToken;
        const currentFromField = mobnum || fromFieldRef.current || fromField || (await getOrCreateUserId());

        if (isLoadingOlder) {
            setIsLoadingOlderMessages(true);
        } else if (!isLoadingOlder && !isLoadingHistory) {
            setIsLoadingHistory(true);
        }

        try {
            console.log('fetchChatHistory called', { isLoadingOlder, lastTimestamp, authToken: currentIdToken, mobnum: currentFromField });
            const formData = new URLSearchParams();
            // Only append if values exist
            if (currentIdToken) formData.append('authorization', currentIdToken);
            if (currentFromField) formData.append('mobnum', currentFromField);
            if (lastTimestamp) {
                formData.append('last_evaluated_ts', lastTimestamp);
            }

            // Log the request
            console.log("Fetching chat history with params:", {
                authorization: currentIdToken,
                mobnum: currentFromField,
                last_evaluated_ts: lastTimestamp
            });

            setCanShowTyping(false);
            const response = await fetch('https://f4uta0ah8g.execute-api.ap-south-1.amazonaws.com/default/bot_chat_history_fetcher', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData
            });

            console.log('History API response:', response);

            if (response.status === 401) {
                console.log("401 Unauthorized: Opening login modal for chat history");
                setLastFailedHistoryParams({ isLoadingOlder, lastTimestamp });
                if (!auth.currentUser && !isModalOpen) setIsModalOpen(true);
                return;
            }

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('History API data:', data);
            console.log("Chat history fetched successfully:", data);

            setHasMoreHistory(!data.results_complete);

            if (data.results && Array.isArray(data.results)) {
                // If no results, set hasMoreHistory to false
                if (data.results.length === 0) {
                    setHasMoreHistory(false);

                    // Only send welcome message if this is the initial load (not pagination), API returned empty, and there is NO hero input
                    if (
                        !isLoadingOlder &&
                        showWelcomeMessage &&
                        !(location && location.state && location.state.heroInput)
                    ) {
                        if (socketRef.current?.readyState === WebSocket.OPEN) {
                            const message = {
                                action: "conversation",
                                headers: { Authorization: latestStateRef.current?.idToken || currentIdToken || '' },
                                body: {
                                    search_stage: "production",
                                    From: latestStateRef.current?.fromField || currentFromField,
                                    msg_src: "web",
                                    api_key: latestStateRef.current.apiKey,
                                    Timestamp: Math.floor(Date.now() / 1000),
                                },
                            };
                            lastMessageRef.current = message;
                            console.log("Sending initial welcome message", JSON.stringify(message, null, 2));
                            socketRef.current.send(JSON.stringify(message));
                            setFirstMessageAfterLogin(false);
                            setShowWelcomeMessage(false);
                        }
                    }
                    // Set historyLoaded to true even if no results
                    if (!isLoadingOlder) {
                        setHistoryLoaded(true);
                        historyLoadedRef.current = true;
                    }

                    callback();

                    return;
                }

                // Use a Set to track unique keys (timestamp + role)
                const seenItems = new Set();
                const uniqueItems = data.results.filter(item => {
                    const key = `${item.timestamp}_${item.role}`;
                    if (seenItems.has(key)) {
                        console.warn(`Duplicate key ${key} from API`);
                        return false;
                    }
                    seenItems.add(key);
                    return true;
                });

                uniqueItems.sort((a, b) => a.timestamp - b.timestamp);

                const processedMessages = uniqueItems.map((item, index) => {
                    const message = {
                        sender: item.role === 'user' ? 'user' : 'bot',
                        text: item.content,
                        timestamp: new Date(item.timestamp * 1000),
                        user_msg_ts: item.timestamp.toString(),
                        id: `history_${Date.now()}_${item.timestamp}_${index}`,
                        isPaginating: false,
                        isHistory: true,
                    };

                    // Handle paginated results
                    if (item.paginated_results && Array.isArray(item.paginated_results) && item.paginated_results.length > 0) {
                        message.paginated_results = processPaginatedResults(item.paginated_results);
                    }

                    // Handle quick replies
                    if (item.quick_replies && item.quick_replies !== "{}") {
                        try {
                            const quickReplies = JSON.parse(item.quick_replies);
                            message.quick_replies = quickReplies;

                            // Set showMoreData if "More routes" exists
                            Object.entries(quickReplies).forEach(([key, value]) => {
                                if (key.includes("More routes")) {
                                    message.showMoreData = { key: key, value: value };
                                }
                            });
                        } catch (error) {
                            console.error("Error parsing quick_replies:", error);
                        }
                    }

                    return message;
                });

                if (isLoadingOlder) {
                    // Build a set of keys for existing messages
                    const existingKeys = new Set();
                    chatMessages.forEach(msg => {
                        // msg.sender is 'user' or 'bot', map to 'user'/'assistant' if needed
                        const role = msg.sender === 'user' ? 'user' : 'assistant';
                        // msg.user_msg_ts may be string, msg.timestamp is Date
                        const ts = msg.user_msg_ts ? Number(msg.user_msg_ts) : (msg.timestamp instanceof Date ? Math.floor(msg.timestamp.getTime() / 1000) : null);
                        if (ts !== null) {
                            existingKeys.add(`${ts}_${role}`);
                        }
                    });

                    // Filter processedMessages to only those not already present
                    const filteredMessages = processedMessages.filter(msg => {
                        const role = msg.sender === 'user' ? 'user' : 'assistant';
                        const ts = msg.user_msg_ts ? Number(msg.user_msg_ts) : (msg.timestamp instanceof Date ? Math.floor(msg.timestamp.getTime() / 1000) : null);
                        if (ts === null) return false;
                        const key = `${ts}_${role}`;
                        return !existingKeys.has(key);
                    });

                    // Prepend older messages to existing chat
                    setChatMessages(prev => [...filteredMessages, ...prev.map(msg => ({ ...msg, isHistory: true }))]);
                    // Do NOT set historyJustLoaded here!
                    // Update last evaluated timestamp for next pagination
                    if (uniqueItems.length > 0) {
                        const firstMessageTimestamp = uniqueItems[0].timestamp;
                        updateLastEvaluatedTimestamp(firstMessageTimestamp);
                        console.log("Updated lastEvaluatedTimestamp (older):", firstMessageTimestamp);
                    }
                } else {
                    // Replace chat messages with new history
                    setChatMessages(processedMessages);
                    setHistoryJustLoaded(true); // <-- Only here!
                    setShowWelcomeMessage(false);
                    setShouldScrollToBottom(true);
                    // Set last evaluated timestamp for pagination
                    if (uniqueItems.length > 0) {
                        const firstMessageTimestamp = uniqueItems[0].timestamp;
                        updateLastEvaluatedTimestamp(firstMessageTimestamp);
                        console.log("Updated lastEvaluatedTimestamp (initial):", firstMessageTimestamp);
                    }
                    // Mark history as loaded
                    historyLoadedRef.current = true;
                    setHistoryLoaded(true);
                }

                //setCurrentBotQueueIdx(-1);

                console.log("Chat history loaded successfully");
            } else {
                // No results, set hasMoreHistory to false
                setHasMoreHistory(false);
                // Set historyLoaded to true even if no results
                if (!isLoadingOlder) {
                    setHistoryLoaded(true);
                    historyLoadedRef.current = true;
                }
            }

            callback();

            console.log("chat ended");

        } catch (error) {
            console.error("Error fetching chat history:", error);
            setConnectionError("Failed to load chat history. Please try again.");
        } finally {
            if (isLoadingOlder) {
                setIsLoadingOlderMessages(false);
            } else {
                setIsLoadingHistory(false);
            }
        }
    };

    // Function to load older messages
    const loadOlderMessages = async () => {
        // const chatContainer = document.querySelector('.chat-history.visible');
        // if (chatContainer) {
        //     prevScrollHeightRef.current = chatContainer.scrollHeight;
        //     prevScrollTopRef.current = chatContainer.scrollTop;
        // }
        isPrependingRef.current = true;

        const previousScrollY = window.scrollY;
        const previousHeight = document.body.scrollHeight;

        const currentTimestamp = lastEvaluatedTimestampRef.current || lastEvaluatedTimestamp;
        if (!hasMoreHistoryRef.current || isLoadingOlderMessages || !currentTimestamp) return;
        await new Promise(resolve => setTimeout(resolve, 100));
        await fetchChatHistory(true, currentTimestamp);

        // requestAnimationFrame(() => {
        //     const newHeight = document.body.scrollHeight;
        //     const heightDiff = newHeight - previousHeight;

        //     window.scrollTo(0, previousScrollY + heightDiff);
        // });
    };

    // Restore scroll position after prepending messages
    // useLayoutEffect(() => {
    //     if (isPrependingRef.current) {
    //         const chatContainer = document.querySelector('.chat-history.visible');
    //         if (chatContainer) {
    //             const newScrollHeight = chatContainer.scrollHeight;
    //             chatContainer.scrollTop = newScrollHeight - prevScrollHeightRef.current + prevScrollTopRef.current;
    //         }
    //         isPrependingRef.current = false;
    //     }
    // }, [chatMessages]);

    // Helper function to update timestamp in both state and ref
    const updateLastEvaluatedTimestamp = (timestamp) => {
        // console.log("Updating timestamp:", {
        //     oldRefValue: lastEvaluatedTimestampRef.current,
        //     oldStateValue: lastEvaluatedTimestamp,
        //     newValue: timestamp
        // });
        setLastEvaluatedTimestamp(timestamp);
        lastEvaluatedTimestampRef.current = timestamp;
    };

    // Handle scroll to load older messages
    const handleScroll = useCallback((e) => {
        //const { scrollTop, scrollHeight, clientHeight } = e.target;
        const { scrollTop } = e;
        // console.log("Scroll event triggered:", {
        //     scrollTop,
        //     //scrollHeight,
        //     //clientHeight,
        //     hasMoreHistory,
        //     isLoadingOlderMessages,
        //     threshold: scrollTop <= 50
        // });

        // If scrolled to top (within 50px threshold) and there are more messages to load
        if (scrollTop <= 1 && hasMoreHistoryRef.current && !isLoadingOlderMessages) {
            //console.log("Loading older messages triggered by scroll");
            // Add visual feedback
            // const chatContainer = e.target;
            // if (chatContainer) {
            //     chatContainer.style.borderTop = "2px solid #FF5B15";
            //     setTimeout(() => {
            //         chatContainer.style.borderTop = "";
            //     }, 2000);
            // }
            loadOlderMessages();
        }
    }, [hasMoreHistoryRef, isLoadingOlderMessages, lastEvaluatedTimestamp]);

    // Single, reliable scroll listener setup
    // useEffect(() => {
    //     const setupScrollListener = () => {
    //         // Find the chat history container
    //         const chatContainer = document.querySelector('.chat-history.visible');

    //         if (chatContainer && !chatContainer.hasAttribute('data-scroll-listener-setup')) {
    //             console.log("Setting up scroll listener for chat history");
    //             chatContainer.setAttribute('data-scroll-listener-setup', 'true');
    //             chatContainer.addEventListener('scroll', handleScroll);

    //             // Log the container details for debugging
    //             console.log("Scroll container details:", {
    //                 scrollHeight: chatContainer.scrollHeight,
    //                 clientHeight: chatContainer.clientHeight,
    //                 scrollTop: chatContainer.scrollTop
    //             });
    //         }
    //     };

    //     // Setup after a delay to ensure DOM is ready
    //     const timeoutId = setTimeout(setupScrollListener, 1000);

    //     return () => {
    //         clearTimeout(timeoutId);
    //         const chatContainer = document.querySelector('.chat-history.visible');
    //         if (chatContainer) {
    //             chatContainer.removeEventListener('scroll', handleScroll);
    //             chatContainer.removeAttribute('data-scroll-listener-setup');
    //         }
    //     };
    // }, [handleScroll]); // Only depend on handleScroll

    useEffect(() => {
        const onScroll = () => {
            //console.log("Window scroll happening:", window.scrollY);
            handleScroll({ scrollTop: window.scrollY });
        };
        window.addEventListener("scroll", onScroll);

        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    const handleLogout = async () => {
        try {
            console.log("tree");
            await signOut(auth);
            setUserProfile({ code: 3 });
            setIdToken(null);
            //setIsModalOpen(true);
            navigate("/chat");
            window.location.reload();
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    const handleTyping = (x) => {
        setTypingEffectCompleted(x);
    }

    // useEffect(() => {
    //     console.log("hasMoreHistory updated:", hasMoreHistory);
    // }, [hasMoreHistory]);

    useEffect(() => {
        hasMoreHistoryRef.current = hasMoreHistory;
    }, [hasMoreHistory]);

    useEffect(() => {
        console.log('isTypingEffectCompleted changed:', isTypingEffectCompleted);
    }, [isTypingEffectCompleted]);

    // --- BOT MESSAGE QUEUE & TYPING EFFECT MANAGEMENT ---
    const botMessageQueue = chatMessages.filter(
        msg => msg.sender === 'bot' && !msg.isHistory
    );
    const [currentBotQueueIdx, setCurrentBotQueueIdx] = useState(0);
    const prevChatMessagesLength = useRef(chatMessages.length);

    // Reset queue index and paginated advance ref on chat history reload/clear
    useEffect(() => {
        // If chatMessages is reset (history reload), set queue index to end so no typing effect is shown
        setCurrentBotQueueIdx(botMessageQueue.length);
    }, [chatMessages.length < prevChatMessagesLength.current]);

    // Track previous chatMessages length to detect resets
    useEffect(() => {
        // If chatMessages is reset (history reload), set queue index to end so no typing effect is shown
        if (chatMessages.length < prevChatMessagesLength.current) {
            // Wait for the next render so botMessageQueue is up to date
            setTimeout(() => {
                setCurrentBotQueueIdx(
                    chatMessages.filter(msg => msg.sender === 'bot' && !msg.isHistory).length
                );
            }, 0);
        }
        prevChatMessagesLength.current = chatMessages.length;
    }, [chatMessages.length]);

    // Guard against index overflow
    useEffect(() => {
        if (currentBotQueueIdx > botMessageQueue.length) {
            setCurrentBotQueueIdx(botMessageQueue.length);
        }
    }, [currentBotQueueIdx, botMessageQueue.length]);

    // - If current bot message has paginated results, advance immediately (no typing effect)
    // - If plain text, advance after typing effect completes
    useEffect(() => {
        console.log('Paginated queue effect fired:', { currentBotQueueIdx, queueLen: botMessageQueue.length });
        // If there are no messages or we're at the last message, do nothing
        if (
            botMessageQueue.length === 0 ||
            currentBotQueueIdx >= botMessageQueue.length - 1 // Only run if there is a next message
        ) {
            return;
        }
        const currentMsg = botMessageQueue[currentBotQueueIdx];
        if (
            currentMsg &&
            currentMsg.paginated_results &&
            currentMsg.paginated_results.length > 0 &&
            (currentBotQueueIdx !== lastPaginatedAdvance.current.idx || currentMsg.id !== lastPaginatedAdvance.current.id)
        ) {
            lastPaginatedAdvance.current = { idx: currentBotQueueIdx, id: currentMsg.id };
            setTimeout(() => {
                setCurrentBotQueueIdx(idx => idx + 1);
            }, 0);
        }
    }, [currentBotQueueIdx, botMessageQueue]);

    // Handler for typing effect completion (plain text bot messages only)
    const handleBotTypingComplete = () => {
        //setShouldScrollToBottom(true);
        setTypingEffectCompleted(true);
        setCurrentBotQueueIdx(idx => idx + 1);
    };

    // Add state to track if history was just loaded
    const [historyJustLoaded, setHistoryJustLoaded] = useState(false);

    // Add a robust effect to set queue index after history reload
    useEffect(() => {
        if (historyJustLoaded) {
            setCurrentBotQueueIdx(
                chatMessages.filter(msg => msg.sender === 'bot' && !msg.isHistory).length
            );
            setHistoryJustLoaded(false);
        }
    }, [chatMessages, historyJustLoaded]);

    // --- Chat Scroll and Typing Effect Management ---
    const chatContainerRef = useRef(null);
    const bottomAnchorRef = useRef(null);
    const userScrolledUpRef = useRef(false);
    const [shouldAutoScroll, setShouldAutoScroll] = useState(true);

    // Track if user is at (or near) the bottom
    const handleChatScroll = useCallback(() => {
        const container = chatContainerRef.current;
        if (!container) return;
        const threshold = 100; // px from bottom to still count as "at bottom"
        const atBottom =
            container.scrollHeight - container.scrollTop - container.clientHeight < threshold;
        userScrolledUpRef.current = !atBottom;
        setShouldAutoScroll(atBottom);
    }, []);

    useEffect(() => {
        const container = chatContainerRef.current;
        if (!container) return;
        container.addEventListener("scroll", handleChatScroll);
        return () => container.removeEventListener("scroll", handleChatScroll);
    }, [handleChatScroll]);

    // Auto-scroll to bottom on new user message or bot typing (if user is at bottom)
    useEffect(() => {
        if (shouldAutoScroll) {
            bottomAnchorRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [chatMessages, !isTypingEffectCompleted, shouldAutoScroll, thinkingData, isWaitingForResponse, currentBotQueueIdx]);

    // Maintain scroll position when loading history (pagination)
    const maintainScrollOnPrepend = () => {
        const container = chatContainerRef.current;
        if (!container) return;
        const prevScrollHeight = container.scrollHeight;
        setTimeout(() => {
            const newScrollHeight = container.scrollHeight;
            container.scrollTop = newScrollHeight - prevScrollHeight + container.scrollTop;
        }, 0);
    };

    // Call fetchChatHistory on initial page load
    useEffect(() => {
        //     fetch("https://api.ipify.org?format=json")
        // .then(response => response.json())
        // .then(data => { 
        //   console.log("User's public IP address is:", data.ip);
        //   //alert(data.ip);
        // })
        // .catch(err => console.error("IP fetch failed:", err));
        //fetchChatHistory();
    }, []);

    return (
        <div className="app-container">
            <style>
                {`
                    .user-dropdown {
                        position: relative;
                        display: inline-block;
                    }
                    
                    .user-dropdown-control {
                        background: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                        padding: 8px 12px !important;
                        cursor: pointer !important;
                        display: flex !important;
                        align-items: center !important;
                        gap: 8px !important;
                        color: #333 !important;
                        font-weight: 500 !important;
                        border-radius: 4px !important;
                    }

                    .user-dropdown-control:focus {
                        outline: none !important;
                        box-shadow: none !important;
                    }
                    
                    .user-dropdown-control img {
                        width: 32px !important;
                        height: 32px !important;
                        border-radius: 50% !important;
                        object-fit: cover !important;
                    }
                    
                    .user-dropdown-control .user-name {
                        font-size: 14px !important;
                        font-weight: 500 !important;
                    }
                    
                    .user-dropdown-control:hover {
                        background: rgba(210, 210, 210, 0.1) !important;
                    }
                    
                    .user-dropdown-menu {
                        position: absolute !important;
                        right: 0 !important;
                        top: 100% !important;
                        background: white !important;
                        border: 1px solid #e0e0e0 !important;
                        border-radius: 4px !important;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
                        margin-top: 4px !important;
                        min-width: 150px !important;
                        z-index: 1001 !important;
                        padding: 4px 0 !important;
                    }
                    
                    .user-dropdown-menu button {
                        width: 100% !important;
                        text-align: left !important;
                        padding: 8px 12px !important;
                        background: none !important;
                        border: none !important;
                        cursor: pointer !important;
                        color: #333 !important;
                        font-size: 14px !important;
                    }
                    
                    .user-dropdown-menu button:focus {
                        outline: none !important;
                        box-shadow: none !important;
                    }

                    .user-dropdown-menu button:hover {
                        background: rgba(239, 239, 239, 0.1) !important;
                    }
                    
                    .user-dropdown-arrow {
                        transition: transform 0.2s !important;
                    }
                    
                    .user-dropdown[data-headlessui-state="open"] .user-dropdown-arrow {
                        transform: rotate(180deg) !important;
                    }

                    .logout-menu-item {
                        width: 100% !important;
                        text-align: left !important;
                        padding: 8px 12px !important;
                        background: none !important;
                        border: none !important;
                        cursor: pointer !important;
                        color: #333 !important;
                        font-size: 14px !important;
                    }

                    .logout-menu-item:focus {
                        outline: none !important;
                        box-shadow: none !important;
                    }

                    .logout-menu-item.is-active {
                        background: rgba(239, 239, 239, 0.1) !important;
                    }

                    .user-dropdown-menu .logout-menu-item {
                        width: 100% !important;
                        text-align: left !important;
                        padding: 8px 12px !importan
                        background: none !important;
                        border: none !important;
                        cursor: pointer !important;
                        color: #333 !important;
                        font-size: 14px !important;
                    }

                    .user-dropdown-menu .logout-menu-item:focus {
                        outline: none !important;
                        box-shadow: none !important;
                    }

                    .user-dropdown-menu .logout-menu-item.is-active {
                        background: rgba(239, 239, 239, 0.1) !important;
                    }
                    
                    .user-dropdown-arrow {
                        transition: transform 0.2s !important;
                    }
                `}
            </style>
            {/* {isInitializing && (
                <div className="initializing-overlay">
                    <div className="initializing-content">
                        <div className="loader">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            )} */}
            <div id={recaptchaContainerId}></div>
            <div className="chat-layout">
                <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
                    <div className="sidebar-top">
                        <button className="menu-btn" aria-label="Menu" onClick={toggleSidebar}>
                            ☰
                        </button>
                        <button className="search-btn" aria-label="Search">🔍</button>
                    </div>
                    <div className="history-list">
                        <div className="history-group">
                            <h2>Recent Chats</h2>
                            {chatMessages
                                .filter((msg) => msg.sender === "user")
                                .slice(0, 5)
                                .map((msg, index) => (
                                    <a key={`sidebar-history-${index}-${msg.timestamp?.getTime() || Date.now()}`} href="#" className="history-item">
                                        {msg.text.slice(0, 30)}...
                                    </a>
                                ))}
                        </div>
                    </div>
                </aside>

                <div className="chat_main_content" >
                    <nav className="top-nav" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
                        <div className="logo" style={{ cursor: 'pointer' }} onClick={() => navigate("/")}>
                            <img src="/logo_new.svg" />
                            <span>
                                <span style={{ color: "#FF5B15", fontWeight: "600", fontSize: '25px' }}>Route</span>
                                <span style={{ color: "#0A0A0A", fontSize: '25px', fontWeight: '400' }}>chef</span>
                            </span>
                        </div>
                        {userProfile.code === 2 ? (
                            <div className="user-profile-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                                <Menu as="div" className="user-dropdown">
                                    <Menu.Button className="user-dropdown-control">
                                        <span className="user-name">{userProfile.displayName}</span>
                                        <img src={userProfile.photoURL} alt="Profile" />
                                        {/* <svg className="user-dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                        </svg> */}
                                    </Menu.Button>
                                    <Menu.Items className="user-dropdown-menu">
                                        <Menu.Item>
                                            {({ active }) => (
                                                <button
                                                    onClick={handleLogout}
                                                    className={`logout-menu-item ${active ? 'is-active' : ''}`}
                                                >
                                                    Logout
                                                </button>
                                            )}
                                        </Menu.Item>
                                    </Menu.Items>
                                </Menu>
                            </div>
                        ) : userProfile.code === 3 ? (
                            <div>
                                <button
                                    style={{
                                        background: '#FF5B15',
                                        width: '100px',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '8px 20px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                    }}
                                    onClick={() => {
                                        setUserClickSignIn(true);
                                        setIsModalOpen(true)
                                    }}
                                >
                                    Sign In
                                </button>
                            </div>
                        ) : null}

                    </nav>

                    <main className="main-content" ref={chatHistoryRef2}>
                        {connectionError && (
                            <div className="error-message" style={{ color: "red", textAlign: "center", padding: "10px" }}>
                                {connectionError}
                            </div>
                        )}

                        {isLoadingHistory && (
                            <div className="loading-history" style={{ textAlign: "center", padding: "20px" }}>
                                <div className="loader">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <p>Loading chat history...</p>
                            </div>
                        )}

                        {showWelcome ? (
                            <div className="welcome-container">
                                <div className="welcome-section">
                                    <h1>Welcome to Routechef.</h1>
                                    <p>Your AI powered travel agent! Ask me anything about your trip plans, PNR status, or travel schedules!</p>
                                    {connectionId && (
                                        <p style={{ fontSize: "12px", color: "#999" }}>
                                            🔗 Connected as: {connectionId}
                                        </p>
                                    )}
                                </div>
                                <div className="search-container center">
                                    <form className="search-bar search-bar2" onSubmit={handleSubmit}>
                                        <div className="search-input">
                                            <img src="/Star1.svg" alt="star" />
                                            <input
                                                type="text"
                                                value={inputMessage}
                                                onChange={(e) => setInputMessage(e.target.value)}
                                                placeholder="Darbhanga se Mumbai jane ke liye kal ki date ke liye routes batao"
                                                aria-label="Chat input"
                                            />
                                        </div>
                                        <button className="search-button" type="submit" aria-label="Send message">
                                            <img src="/send.svg" alt="send" />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="chat-history visible" ref={chatHistoryRef}>
                                    {isLoadingOlderMessages && (
                                        <div className="loading-older-messages" style={{ textAlign: "center", padding: "10px" }}>
                                            <div className="loader">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                            <p>Loading older messages...</p>
                                        </div>
                                    )}

                                    {groupedMessages.map((group, groupIndex) => (
                                        <div key={`group-${groupIndex}-${group[0]?.timestamp?.getTime() || Date.now()}`} className="message-group">
                                            {group.map((msg, msgIndex) => {
                                                let renderedMessage = null;
                                                // User message
                                                if (msg.sender === 'user') {
                                                    renderedMessage = (
                                                        <div key={msg.id || `msg-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`} className="message user-message">
                                                            <div className="chat-container">
                                                                <div className="message-bubble">
                                                                    <p dangerouslySetInnerHTML={{ __html: formatBold(msg.text) }} />
                                                                </div>
                                                                <span className="timestamp user-timestamp">{new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                } else if (msg.isHistory) {
                                                    if (msg.paginated_results && msg.paginated_results.length > 0) {
                                                        renderedMessage = (
                                                            <div key={msg.id || `msg-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`} className="message bot-message">
                                                                <ChatComp
                                                                    data={msg.paginated_results}
                                                                    showMoreData={msg.showMoreData}
                                                                    handleShowMore={(key, value) => {
                                                                        const messageId = msg.id || Date.now().toString();
                                                                        handlePaginationRequest(key, value, messageId);
                                                                    }}
                                                                    isPaginating={msg.isPaginating || false}
                                                                    selectedTravelOption={selectedTravelOptions[msg.id]}
                                                                    onTravelOptionSelect={(item) => handleTravelOptionSelect(item, msg.id)}
                                                                />
                                                            </div>
                                                        );
                                                    } else {
                                                        renderedMessage = (
                                                            <div key={msg.id || `msg-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`} className="message bot-message">
                                                                <div className="chat-container">

                                                                    <div className="message-bubble">

                                                                        <div className="bot-message-content">
                                                                            <img src="/Star1.svg" alt="star" className="bot-star-icon" />
                                                                            <p dangerouslySetInnerHTML={{ __html: formatBold(msg.text) }} />
                                                                        </div>

                                                                    </div>
                                                                    <span className="timestamp bot-timestamp">{new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                } else if (msg.sender === 'bot' && !msg.isHistory) {
                                                    // Find this message's index in the botMessageQueue
                                                    const globalBotIdx = botMessageQueue.findIndex(m => m === msg);
                                                    if (globalBotIdx > currentBotQueueIdx) {
                                                        // Don't render this bot message yet
                                                        return null;
                                                    }
                                                    if (msg.paginated_results && msg.paginated_results.length > 0 && globalBotIdx === currentBotQueueIdx) {
                                                        // Show paginated result (no typing effect)
                                                        //handleBotTypingComplete
                                                        renderedMessage = (
                                                            <div key={msg.id || `msg-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`} className="message bot-message">
                                                                <ChatComp
                                                                    data={msg.paginated_results}
                                                                    showMoreData={msg.showMoreData}
                                                                    handleShowMore={(key, value) => {
                                                                        const messageId = msg.id || Date.now().toString();
                                                                        handlePaginationRequest(key, value, messageId);
                                                                    }}
                                                                    isPaginating={msg.isPaginating || false}
                                                                    selectedTravelOption={selectedTravelOptions[msg.id]}
                                                                    onTravelOptionSelect={(item) => handleTravelOptionSelect(item, msg.id)}
                                                                />
                                                            </div>
                                                        );
                                                    } else if (msg.paginated_results && msg.paginated_results.length > 0) {
                                                        // Show paginated result for previous messages
                                                        renderedMessage = (
                                                            <div key={msg.id || `msg-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`} className="message bot-message">
                                                                <ChatComp
                                                                    data={msg.paginated_results}
                                                                    showMoreData={msg.showMoreData}
                                                                    handleShowMore={(key, value) => {
                                                                        const messageId = msg.id || Date.now().toString();
                                                                        handlePaginationRequest(key, value, messageId);
                                                                    }}
                                                                    isPaginating={msg.isPaginating || false}
                                                                    selectedTravelOption={selectedTravelOptions[msg.id]}
                                                                    onTravelOptionSelect={(item) => handleTravelOptionSelect(item, msg.id)}
                                                                />
                                                            </div>
                                                        );
                                                    } else if (globalBotIdx === currentBotQueueIdx && currentBotQueueIdx < botMessageQueue.length) {
                                                        // if(!canShowTyping){
                                                        //     //handleBotTypingComplete();
                                                        //     //setTypingEffectCompleted(false);
                                                        //     return null;
                                                        // }

                                                        // Debug log for typing effect rendering
                                                        console.log('Typing effect condition:', 'globalBotIdx:', globalBotIdx, 'currentBotQueueIdx:', currentBotQueueIdx, 'botQueueLen:', botMessageQueue.length, 'msg:', msg.text);
                                                        // Show typing effect for the current bot message (only if not after history reload)
                                                        renderedMessage = (
                                                            <div key={msg.id || `msg-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`} className="message bot-message">
                                                                <div className="chat-container">
                                                                    <div className="message-bubble">
                                                                        <div className="bot-message-content">
                                                                            <img src="/Star1.svg" alt="star" className="bot-star-icon" />
                                                                            <ChatGPTTypingEffect
                                                                                key={msg.id || msg.timestamp || msg.text}
                                                                                messages={[msg.text]}
                                                                                onTypingStart={(msg, idx) => {
                                                                                    setTypingEffectCompleted(false);
                                                                                    //msg.isTypingDone=false;
                                                                                }}
                                                                                typingSpeed={5}
                                                                                pauseBetween={100}
                                                                                onComplete={handleBotTypingComplete}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <span className="timestamp bot-timestamp">{new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    } else {
                                                        // Show plain text for previous bot messages
                                                        renderedMessage = (
                                                            <div key={msg.id || `msg-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`} className="message bot-message">
                                                                <div className="chat-container">
                                                                    <div className="message-bubble">
                                                                        <div className="bot-message-content">
                                                                            <img src="/Star1.svg" alt="star" className="bot-star-icon" />
                                                                            <p dangerouslySetInnerHTML={{ __html: formatBold(msg.text) }} />
                                                                        </div>
                                                                    </div>
                                                                    <span className="timestamp bot-timestamp">{new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                }
                                                // Render the message and, if present, the quick replies block
                                                return (
                                                    <React.Fragment key={msg.id || `frag-${msgIndex}-${msg.timestamp?.getTime() || Date.now()}`}>
                                                        {renderedMessage}
                                                        {msg.quick_replies && Object.keys(msg.quick_replies).length > 0 && (
                                                            <div className="message bot-message quick-replies-container">
                                                                <div className="message-bubble" style={{ border: 'none', boxShadow: 'none' }}>
                                                                    <div className="bot-message-content">
                                                                        <div className="quick-replies">
                                                                            {Object.entries(msg.quick_replies).map(([text, id], index) =>
                                                                                !text.startsWith("Detailed") && !text.includes("More routes") ? (
                                                                                    <button
                                                                                        key={`${text}-${id}`}
                                                                                        className="quick-reply-btn"
                                                                                        onClick={() => handleUserReply(text, id, msg.user_msg_ts)}
                                                                                        aria-label={`Quick reply: ${text}`}
                                                                                    >
                                                                                        {text}
                                                                                    </button>
                                                                                ) : null
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    ))}
                                    {((isWaitingForResponse || (isMoreRepliesLoading && isTypingEffectCompleted) || thinkingData) && currentBotQueueIdx >= botMessageQueue.length) && (
                                        <div className="chat-container" style={{ margin: 'auto', width: '100%', maxWidth: '800px' }}>
                                            <div className="message-group">
                                                {thinkingData ? (
                                                    <AIThinkingComponent
                                                        thinking_title={thinkingData.thinking_title}
                                                        thinking_desc={thinkingData.thinking_desc}
                                                        isThinking={true}
                                                    />
                                                ) : (
                                                    <div className="message bot-message">
                                                        <div className="message-bubble" style={{ alignSelf: 'flex-start' }}>
                                                            <div className="bot-message-content">
                                                                <img src="/Star1.svg" alt="star" className="bot-star-icon" />
                                                                <div className="typing-indicator">
                                                                    <span></span>
                                                                    <span></span>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    <div ref={bottomAnchorRef} style={{ height: '1px' }} />
                                </div>
                                <div className="search-container bottom" style={{ backgroundColor: 'white' }}>
                                    <form className="search-bar search-bar2" onSubmit={handleSubmit}>
                                        <div className="search-input">
                                            <img src="/Star1.svg" alt="star" />
                                            <input
                                                type="text"
                                                value={inputMessage}
                                                onChange={(e) => setInputMessage(e.target.value)}
                                                placeholder="Darbhanga se Mumbai jane ke liye kal ki date ke liye routes batao"
                                                aria-label="Chat input"
                                                disabled={isWaitingForResponse || isMoreRepliesLoading}
                                            />
                                        </div>
                                        {inputMessage.trim() && (
                                            <button
                                                className="search-button"
                                                type="submit"
                                                aria-label="Send message"
                                                disabled={isWaitingForResponse || isMoreRepliesLoading}
                                            >
                                                {(isWaitingForResponse || isMoreRepliesLoading) ? (
                                                    <div className="button-loader">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                ) : (
                                                    <img src="/send.svg" alt="send" />
                                                )}
                                            </button>
                                        )}
                                    </form>
                                </div>
                            </>
                        )}

                        {isModalOpen && (
                            <div className="modal-backdrop">
                                <div className="modal-content">
                                    <button
                                        className="modal-close-btn"
                                        aria-label="Close modal"
                                        style={{
                                            position: 'absolute',
                                            top: '16px',
                                            right: '16px',
                                            background: 'transparent',
                                            border: 'none',
                                            fontSize: '24px',
                                            cursor: 'pointer',
                                            zIndex: 10
                                        }}
                                        onClick={() => {
                                            setUserClickSignIn(false);
                                            setIsModalOpen(false);
                                            // Reset any stuck loaders when modal is closed
                                            setChatMessages(prev => prev.map(msg =>
                                                msg.isPaginating ? { ...msg, isPaginating: false } : msg
                                            ));
                                            setPendingPaginationUpdate(null);
                                            latestStateRef.current.pendingPaginationUpdate = null;
                                        }}
                                    >
                                        &times;
                                    </button>

                                    <div className="login-logo">
                                        <img src="/logo_new.svg" alt="Routechef Logo" />
                                        <span>
                                            <span style={{ color: "#FF5B15", fontWeight: "600" }}>Route</span>
                                            <span style={{ color: "#0A0A0A", fontWeight: '400' }}>chef</span>
                                        </span>
                                    </div>
                                    <h2 className="welcome-back">Welcome back</h2>

                                    <button
                                        className="modal-oauth-btn google-btn"
                                        onClick={handleGoogleLogin}
                                        disabled={isLoginLoading}
                                        style={{ opacity: isLoginLoading ? 0.7 : 1, cursor: isLoginLoading ? 'not-allowed' : 'pointer' }}
                                    >
                                        {isLoginLoading ? (
                                            <div className="button-loader" style={{ marginRight: '8px' }}>
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        ) : (
                                            <img src="/googleIcon.svg" alt="Google Icon" className="google-icon" />
                                        )}
                                        <span>{isLoginLoading ? 'Signing in...' : 'Sign in with Google'}</span>
                                    </button>

                                    <div className="modal-divider-new">
                                        <span>OR</span>
                                    </div>

                                    {!otpSent ? (
                                        <form className="modal-login-form" onSubmit={handleSendOtp}>
                                            <label htmlFor="mobile-input">Mobile Number</label>
                                            <PhoneInput
                                                country={'in'}
                                                value={mobileNumber}
                                                onChange={setMobileNumber}
                                                disableFormatting={true}
                                                inputProps={{
                                                    id: 'mobile-input',
                                                    required: true,
                                                    name: 'mobile',
                                                    autoFocus: true,
                                                    'aria-label': 'Mobile number input',
                                                    disabled: isLoginLoading,
                                                }}
                                                enableSearch={true}
                                                containerClass="phone-input-container"
                                                inputClass="phone-input-field"
                                                buttonClass="phone-input-dropdown"
                                                dropdownClass="phone-input-country-dropdown"
                                            />
                                            <button
                                                type="submit"
                                                className="modal-login-btn sign-in-btn"
                                                disabled={isLoginLoading}
                                                style={{ opacity: isLoginLoading ? 0.7 : 1, cursor: isLoginLoading ? 'not-allowed' : 'pointer' }}
                                            >
                                                {isLoginLoading ? (
                                                    <div className="button-loader">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                ) : (
                                                    'Send OTP'
                                                )}
                                            </button>
                                        </form>
                                    ) : (
                                        <form className="modal-login-form" onSubmit={handleVerifyOtp}>
                                            <label htmlFor="otp-input">Enter OTP</label>
                                            <input
                                                id="otp-input"
                                                type="text"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                placeholder="Enter the 6-digit OTP"
                                                aria-label="OTP input"
                                                className="login-input"
                                                disabled={isLoginLoading}
                                            />
                                            <button
                                                type="submit"
                                                className="modal-login-btn sign-in-btn"
                                                disabled={isLoginLoading}
                                                style={{ opacity: isLoginLoading ? 0.7 : 1, cursor: isLoginLoading ? 'not-allowed' : 'pointer' }}
                                            >
                                                {isLoginLoading ? (
                                                    <div className="button-loader">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                ) : (
                                                    'Verify OTP'
                                                )}
                                            </button>
                                        </form>
                                    )}
                                </div>
                            </div>
                        )}
                    </main>
                </div>
            </div>
        </div>
    );
}